import { Box, InfoDot, Text } from '@factorialco/deprecated-design-system'
import { EmployeeTimePeriodDetailsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ZERO_HOURS } from 'modules/shift_management/components/ShiftManagement/TimeInsightsSidepanel/Content/utils'

interface Props {
  employeeData: EmployeeTimePeriodDetailsFragment
  convertHours: boolean
}

const TotalPlannedTooltip = ({ employeeData, convertHours }: Props) => {
  const standardPlannedHours = employeeData.standardPlannedHours
  const additionalHours = employeeData.additionalPlannedHours
  const paidLeavesHours = employeeData.paidLeavesHours
  const overPlannedHours = employeeData.overplannedHours
  const overplannedHoursWithoutAdditional = employeeData.overplannedHoursWithoutAdditional
  const overPlannedHoursToShow = convertHours ? overPlannedHours : overplannedHoursWithoutAdditional

  const planned = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.planned'
  )

  const additional = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.additional'
  )

  const paidLeaves = i18n.t('shift_management.hours_information.approved_leaves')
  const overplanned = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.overplanned'
  )

  const totalHours = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.total_hours'
  )

  const totalStandardPlannedHours = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.hours_new',
    {
      hours: Number(standardPlannedHours),
    }
  )
  const totalAdditionalHours = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.hours_new',
    {
      hours: Number(additionalHours),
    }
  )
  const totalPaidLeaveHours = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.hours_new',
    {
      hours: Number(paidLeavesHours),
    }
  )
  const totalOverplannedHours = i18n.t(
    'shift_management.time_insights.time_balance_content.planned_time.table.stacked_bars.hours_new',
    {
      hours: Number(overPlannedHoursToShow),
    }
  )

  return (
    <Box minWidth="s240" padding="s6" gap="s16">
      <Box flexDirection="row" alignItems="center">
        <Text.Normal size="200" weight="semibold">
          {totalHours}
        </Text.Normal>
      </Box>
      <Box gap="s8">
        <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <InfoDot size="medium" color="viridian1000" />
            <Text.Normal size="200" weight="semibold">
              {planned}
            </Text.Normal>
          </Box>
          <Text.Normal size="200" weight="semibold">
            {totalStandardPlannedHours}
          </Text.Normal>
        </Box>

        {convertHours && additionalHours !== ZERO_HOURS && (
          <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
            <Box flexDirection="row" gap="s8" alignItems="center">
              <InfoDot size="medium" color="malibu1000" />
              <Text.Normal size="200" weight="semibold">
                {additional}
              </Text.Normal>
            </Box>
            <Text.Normal size="200" weight="semibold">
              {totalAdditionalHours}
            </Text.Normal>
          </Box>
        )}

        {paidLeavesHours !== ZERO_HOURS && (
          <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
            <Box flexDirection="row" gap="s8" alignItems="center">
              <InfoDot size="medium" color="champagne1000" />
              <Text.Normal size="200" weight="semibold">
                {paidLeaves}
              </Text.Normal>
            </Box>
            <Text.Normal size="200" weight="semibold">
              {totalPaidLeaveHours}
            </Text.Normal>
          </Box>
        )}

        {convertHours ? (
          <>
            {overPlannedHours !== ZERO_HOURS && (
              <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
                <Box flexDirection="row" gap="s8" alignItems="center">
                  <InfoDot size="medium" color="tangerine1000" />
                  <Text.Normal size="200" weight="semibold">
                    {overplanned}
                  </Text.Normal>
                </Box>
                <Text.Normal size="200" weight="semibold">
                  {totalOverplannedHours}
                </Text.Normal>
              </Box>
            )}
          </>
        ) : (
          <>
            {overplannedHoursWithoutAdditional !== ZERO_HOURS && (
              <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
                <Box flexDirection="row" gap="s8" alignItems="center">
                  <InfoDot size="medium" color="tangerine1000" />
                  <Text.Normal size="200" weight="semibold">
                    {overplanned}
                  </Text.Normal>
                </Box>
                <Text.Normal size="200" weight="semibold">
                  {totalOverplannedHours}
                </Text.Normal>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

export default TotalPlannedTooltip
